import * as React from 'react';
import { Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';
import { Team } from '../../../../sdk/model';
import { teamApi } from '../../../../adapters/APIExporter';

interface MockEventOptionsDialogProps {
  eventType: string,
  myTeam: Team | undefined,
  leagueId: string
}

function MockEventOptionsDialog(props: MockEventOptionsDialogProps) {
  const [nameConfirmed, setNameConfirmed] = React.useState(false);
  const [mutableTeam, setMutableTeam] = React.useState({...props.myTeam});
  const [errors, setErrors] = React.useState([]);
  
  React.useEffect(() => {
    if (!mutableTeam.name) {
      setMutableTeam({...props.myTeam})
    }
  }, [props.myTeam]);
  
  function handleTeamChange(event) {
    const {name, value} = event.target;
    const newTeam = {...mutableTeam};
    newTeam[name] = value;
    setMutableTeam(newTeam);
  }
  
  const validateTeamName = (value, errors) => {
    if (value.length < 3 || value.length > 25) {
      errors.push('You must provide a Team Name with a length between 3 and 25 characters');
    }
  }
  
  function confirmTeamName() {
    let newErrors = [];
    validateTeamName(mutableTeam.name, newErrors);
    setErrors(newErrors);
    if (newErrors.length > 0) {
      return;
    }
    teamApi.updateTeam(mutableTeam.id, mutableTeam)
      .then(() => setNameConfirmed(true))
      .catch((error) => {
        newErrors.push(error.response.data.message);
        setErrors(newErrors);
      });
  }
  
  function joinTeam() {
    teamApi.joinTeamInLeague(props.leagueId);
  }
  
  function leaveTeam() {
    teamApi.leaveTeam(props.myTeam?.id).then(() => setMutableTeam({}))
  }
  
  let errorInfo = errors.map((error, index) => {
    return (<p className='error' key={'error_' + index}>{error}</p>);
  });
  
  return <Dialog open={!nameConfirmed} maxWidth="sm" fullWidth>
    <DialogTitle>Mock {props.eventType}</DialogTitle>
    {!!props.myTeam ? 
      <React.Fragment>
        <DialogContent>
          {errorInfo}
          <Typography>Choose your team name for this Mock {props.eventType}</Typography>
          <TextField name='name' label="Team Name" value={mutableTeam.name}
                    onChange={handleTeamChange}/>
        </DialogContent>
        <DialogActions>
          <Button color="primary" variant="contained" disabled={!mutableTeam.name} onClick={confirmTeamName}>
            Confirm
          </Button>
          <Button color="secondary" variant="contained" disabled={!mutableTeam.name} onClick={leaveTeam}>
            Leave Team
          </Button>
        </DialogActions>
      </React.Fragment> :
      <React.Fragment>
        <DialogContent>
          {errorInfo}
          <Typography>Would you like to join a team in this Mock {props.eventType}?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button color="primary" variant="contained" onClick={joinTeam}>
            Yes
          </Button>
          <Button color="secondary" variant="contained" onClick={() => setNameConfirmed(true)}>
            No, I'm just watching
          </Button>
        </DialogActions>
      </React.Fragment>
    }
  </Dialog>
}

export default MockEventOptionsDialog;
